var o = ((n) => (n.development = "development", n.staging = "staging", n.production = "production", n.test = "test", n))(o || {});
function e() {
  return window.adobeIMS && window.adobeIMS.adobeIdData.environment === "stg1" ? "staging" : "production";
}
const t = () => e() === "development", i = () => e() === "production", s = () => e() === "test";
export {
  o as Environment,
  e as getEnvironment,
  t as isDevelopment,
  i as isProduction,
  s as isTest
};
//# sourceMappingURL=Environment.js.map
